import axios from "axios";
import ConsoleLocalStorage from "../storage/storage";
import { DEV_CONSOLE_URL, APP_MANAGEMENT_URL } from "../config";
import { projectStatus } from "../util/helpers/statusHelper";
export default class DevProjectAPI {
  instance = axios.create({
    baseURL: DEV_CONSOLE_URL,
    headers: {
      Authorization: "Bearer " + ConsoleLocalStorage.getAccessToken(),
      "x-organization-id": ConsoleLocalStorage?.getUser()?.organization,
    },
  });

  amInstance = axios.create({
    baseURL: APP_MANAGEMENT_URL,
    headers: {
      Authorization: "Bearer " + ConsoleLocalStorage.getAccessToken(),
      "x-organization-id": ConsoleLocalStorage?.getUser()?.organization,
    },
  });

  createProject(data) {
    return this.instance.post("project", data);
  }

  getOneProject(id) {
    return this.instance.get("project/" + id);
  }

  getAllProject() {
    return this.instance.get("project");
  }
  uploadDEA(id, data) {
    return this.instance.put("project/" + id, data);
  }
  getPendingApps() {
    return this.instance.get("application/pending/app");
  }
  getProjectCount(projectId,status,os='android'){
    if(status !== projectStatus.pending.status)
      return this.amInstance.get(`project/${projectId}/application/count?appOS=${os}`);
    else
      return false;
  }
  getAppCreationConfig(){
    return this.instance.get("application/config");
  }
}
